import { Card } from 'react-bootstrap';

export default function WIPCard() {
  return (
    <Card body className="my-4">
      <h1 className="display-1 text-center">Coming Soon&trade;</h1>
    </Card>
  );
}
